/* istanbul ignore next */
const ACTIONS = {
    SET_FIRST_NAME: 'SET_FIRST_NAME',
    SET_LAST_NAME: 'SET_LAST_NAME',
    SET_DIALING_COUNTRY_CODE: 'SET_DIALING_COUNTRY_CODE',
    SET_COUNTRY_DIALING_NUMBER: 'SET_COUNTRY_DIALING_NUMBER',
    SET_PHONE_NUMBER: 'SET_PHONE_NUMBER',
    SET_COMPANY_NAME: 'SET_COMPANY_NAME',
    SET_EMAIL: 'SET_EMAIL',
    SET_PASSWORD: 'SET_PASSWORD',
    SET_PASSWORD_TYPE: 'SET_PASSWORD_TYPE',
    SET_FIELD_ERROR: 'SET_FIELD_ERROR',
    VALIDATE_FIRST_NAME: 'VALIDATE_FIRST_NAME',
    VALIDATE_LAST_NAME: 'VALIDATE_LAST_NAME',
    VALIDATE_COMPANY_NAME: 'VALIDATE_COMPANY_NAME',
    VALIDATE_EMAIL: 'VALIDATE_EMAIL',
    VALIDATE_PASSWORD: 'VALIDATE_PASSWORD',
    VALIDATE_PHONE: 'VALIDATE_PHONE',
    CREATE_ACCOUNT: 'CREATE_ACCOUNT',
    CREATE_ACCOUNT_SERVICE_ERROR: 'CREATE_ACCOUNT_SERVICE_ERROR',
    SET_PASSWORD_NOTIFICATIONS: 'SET_PASSWORD_NOTIFICATIONS',
    ACCOUNT_CONFLICT_WARNING: 'ACCOUNT_CONFLICT_WARNING',
    TOGGLE_AC_CONTINUE_BUTTON: 'TOGGLE_AC_CONTINUE_BUTTON',
    PRE_POPULATE_BASIC_INFO: 'PRE_POPULATE_BASIC_INFO'
};

/* istanbul ignore next */
const ACTION_CREATORS = {
    setFirstName(fieldVal) {
        return {
            type: ACTIONS.SET_FIRST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setLastName(fieldVal) {
        return {
            type: ACTIONS.SET_LAST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setDialingCountryCode(fieldVal) {
        return {
            type: ACTIONS.SET_DIALING_COUNTRY_CODE,
            payload: {
                fieldVal
            }
        };
    },

    setCountryDialingNumber(fieldVal) {
        return {
            type: ACTIONS.SET_COUNTRY_DIALING_NUMBER,
            payload: {
                fieldVal
            }
        };
    },

    setPhoneNumber(fieldVal) {
        return {
            type: ACTIONS.SET_PHONE_NUMBER,
            payload: {
                fieldVal
            }
        };
    },

    setCompanyName(fieldVal) {
        return {
            type: ACTIONS.SET_COMPANY_NAME,
            payload: {
                fieldVal
            }
        };
    },

    setEmail(fieldVal) {
        return {
            type: ACTIONS.SET_EMAIL,
            payload: {
                fieldVal
            }
        };
    },

    setPassword(fieldVal) {
        return {
            type: ACTIONS.SET_PASSWORD,
            payload: {
                fieldVal
            }
        };
    },

    setPasswordType(fieldVal) {
        return {
            type: ACTIONS.SET_PASSWORD_TYPE,
            payload: {
                fieldVal
            }
        };
    },

    setPasswordNotify(fieldVal) {
        return {
            type: ACTIONS.SET_PASSWORD_NOTIFICATIONS,
            payload: {
                fieldVal
            }
        };
    },

    setFieldError(field, msg) {
        return {
            type: ACTIONS.SET_FIELD_ERROR,
            payload: {
                field,
                msg
            }
        };
    },

    validateFirstName(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_FIRST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    validateLastName(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_LAST_NAME,
            payload: {
                fieldVal
            }
        };
    },

    validateCompanyName(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_COMPANY_NAME,
            payload: {
                fieldVal
            }
        };
    },

    validateEmail(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_EMAIL,
            payload: {
                fieldVal
            }
        };
    },

    validatePhone(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_PHONE,
            payload: {
                fieldVal
            }
        };
    },

    validatePassword(fieldVal) {
        return {
            type: ACTIONS.VALIDATE_PASSWORD,
            payload: {
                fieldVal
            }
        };
    },

    createAccount(accountDetails) {
        return {
            type: ACTIONS.CREATE_ACCOUNT,
            payload: {
                accountDetails
            }
        };
    },

    alertError(errorKey) {
        return {
            type: ACTIONS.CREATE_ACCOUNT_SERVICE_ERROR,
            payload: {
                errorKey
            }
        };
    },

    setAccountExistsError(errorKey) {
        return {
            type: ACTIONS.ACCOUNT_CONFLICT_WARNING,
            payload: {
                errorKey
            }
        };
    },

    toggleContinueButton() {
        return {
            type: ACTIONS.TOGGLE_AC_CONTINUE_BUTTON
        };
    },

    prePopulateBasicInfo(brandSwitchParams) {
        return {
            type: ACTIONS.PRE_POPULATE_BASIC_INFO,
            payload: {
                brandSwitchParams
            }
        }
    }
};

export default {
    ...ACTIONS,
    ...ACTION_CREATORS
};
